<template>
<div class="custom-modal-wrap overflow-y-auto  overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex">
    <div class="absolute top-[30px] left-0 flex justify-center items-center  my-0 mx-auto right-0 w-full z-10 text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
        <div class="w-[650px] transition-width duration-500 mx-auto mt-14 bg-light-black px-[24px] py-[16px] rounded-lg">
            <div class="flex justify-between relative pb-5">
                <span class="text-[20px]">Purchase Order AI Prompts</span>
                <div class="flex flex-row justify-between gap-3">
                    <button @click.prevent="close()" class="cursor-pointer rounded-md bg-white text-theme-green py-2 px-4 hover:bg-theme-darkgreen hover:text-white">
                        Cancel
                    </button>
                    <button @click.prevent="save()" class="cursor-pointer rounded-md bg-theme-green text-white py-2 px-4 hover:bg-theme-darkgreen hover:text-white">
                        Save
                    </button>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="w-full">
                    <div :class="'input-wrapper ' + (form.title.error_type)">
                        <label class="text-[14px] mb-1">Title</label>
                        <input v-model="form.title.value" @keyup="validateFields(['title'])" placeholder="Enter a title for prompt" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white h-[40px]" type="text">
                        <p class="field-error label-text mt-1" v-if="form.title.error_message" v-text="form.title.error_message"></p>
                    </div>
                </div>
                <div class="w-full">
                    <div :class="'input-wrapper ' + (form.prompt.error_type)">
                        <label class="text-[14px] mb-1">Prompt</label>
                        <textarea v-model="form.prompt.value" rows="16" @keyup="validateFields(['prompt'])" placeholder="Enter a prompt here" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white"></textarea>
                        <p class="field-error label-text mt-1" v-if="form.prompt.error_message" v-text="form.prompt.error_message"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Helpers from '@/helpers';
import {defineComponent, ref} from "vue"
import {mapActions} from "vuex";
import { useSnackbar} from "vue3-snackbar";
import PoAiApi from '@/controllers/PoAi'

export default defineComponent({
    props: ['data'],
    setup() {
        const snackbar = useSnackbar();
        const form = ref({
            title: {
                value: '',
                error_type: '',
                error_message: '',
                validations: ['required'],
            },
            prompt: {
                value: '',
                error_type: '',
                error_message: '',
                validations: [''],
            },
        })

        return {snackbar, form}

    },
    mounted(){
        this.assignValues()
    },
    methods: {
        async assignValues() {
            this.form = await Helpers.assignFormValues(this.form, this.data)
        },
        /**
         * Validation captures
         */
        async validateFields(fields) {
            let res = await Helpers.validateFormFields(this.form, fields);
            // capture the fields
            this.form = res.data;
            return res.error ? false : true;
        },
        close(){
            this.$emit('close')
        },
        async save(){
            // validate business field
            let validate = await this.validateFields(['title', 'prompt']);
            if(!validate) {
                return ;
            }

            this.va_spinner(true);
            let formData = {
                title: this.form.title.value,
                prompt: this.form.prompt.value,
            }
            let res = null
            if(this.data.id) {
                res = await PoAiApi.updatePoAI(this.data.id, formData);
            }else{
                res = await PoAiApi.addPoAI(formData);
            }
            
       
            this.snackbar.add({
                type: 'info',
                text: (res.status == 201 || res.status == 200) ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            if(res.status == 201 || res.status == 200 ) {
                this.$emit('close')
                this.emitter.emit("refresh-po-ai-list", true);
            }
            this.va_spinner(false);
        },
        ...mapActions({
            va_spinner: 'spinner/setSpinner',
        })
    }
})
</script>